var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import LoginForm from '../../components/Login/LoginForm';
import messages from './messages';
import commonMessages from '../../message.common';
import injectIntl from '../../utils/injectIntl';
import * as rootActions from '../Root/actions';
import { makeSelectUser } from '../Root/selectors';
import AppspotrWhiteLogo from '../../images/logos/appspotrWhite.svg';
import { P } from '../../components/UI-helpers/typography';
import { LoginImage, LoginDetails, LoginPageWrapper, LoginImageWrapper, LoginPageContainer, } from './styles';
var LoginPage = /** @class */ (function (_super) {
    __extends(LoginPage, _super);
    function LoginPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoginPage.prototype.render = function () {
        var _a = this.props, intl = _a.intl, user = _a.user, onLogin = _a.onLogin, goToResetPassword = _a.goToResetPassword, _b = _a.location, pathname = _b.pathname, search = _b.search;
        var from = (this.props.location.state || { from: { pathname: '/' } }).from;
        if (this.props.user.token && from !== '/') {
            return _jsx(Redirect, { to: from });
        }
        var isPrivacy = pathname && pathname.includes('/privacy');
        var isTerms = pathname && pathname.includes('/terms');
        var isTokenExpired = pathname && pathname.includes('/token');
        var welcomeMessage = '';
        if (isPrivacy) {
            welcomeMessage = 'You have declined our Privacy Policies';
        }
        if (isTerms) {
            welcomeMessage = 'You have declined our Terms & Conditions';
        }
        if (isTokenExpired) {
            welcomeMessage = 'Your session has expired, please log in again';
        }
        return (_jsxs(_Fragment, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: intl.formatMessage(__assign({}, commonMessages.login)) }), _jsx("meta", { name: "description", content: intl.formatMessage(__assign({}, messages.header)) })] }), _jsx(LoginPageContainer, { children: _jsxs(LoginPageWrapper, { children: [_jsx(LoginImageWrapper, { children: _jsx(LoginImage, { src: AppspotrWhiteLogo, alt: "" }) }), _jsx(LoginDetails, { children: _jsx(P, __assign({ fontSize: 16, bold: true, white: true }, { children: "Log into your account" })) }), _jsx(LoginForm, { user: user, onLogin: onLogin, onForgotPassword: goToResetPassword, urlParam: search, welcomeMessage: welcomeMessage, isPrivacy: isPrivacy, isTerms: isTerms, isTokenExpired: isTokenExpired })] }) })] }));
    };
    return LoginPage;
}(React.Component));
var mapStateToProps = createStructuredSelector({
    user: makeSelectUser(),
});
var mapDispatchToProps = function (dispatch) { return ({
    goBack: function (urlParam) { return dispatch(push("/?".concat(urlParam))); },
    onLogin: function (_a) {
        var email = _a.email, password = _a.password, code = _a.code, urlParam = _a.urlParam;
        dispatch(rootActions.login(email, password, code, urlParam));
    },
    goToResetPassword: function () {
        dispatch(push('/password-reset'));
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(injectIntl, withConnect)(LoginPage);
